export const track = (event, params = {}) => {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, ...params });
        if (typeof window.fbq === "function") window.fbq("trackCustom", event, params);
    } catch (e) {
        /* analytics nunca quebra a experiência */
    }
};
